import React from 'react';
import { Container, makeStyles } from '@material-ui/core';
import Page from '@components/template/Page';
import PageHeader from '@components/organisms/PageHeader/index';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import VipTable from '@pages/contacts/body/VipTable';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const VipContactListView = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Admin">
      <Container maxWidth="lg">
        <PageHeader
          title="VIP 문의"
          subTitle="문의 목록"
          icon={<ShowChartIcon fontSize="large" />}
        />
        <VipTable />
      </Container>
    </Page>
  );
};

export default VipContactListView;
